export const getWPNonce = (): string => {
	const nonce = document
		.getElementById('maxx-roleta-theme')
		?.getAttribute('data-nonce');

	if (!nonce) {
		throw new Error('Nonce not found');
	}

	return nonce;
};
